import { AppBar, Box, IconButton, Toolbar, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

export default function DialogAppBar({
    title,
    handleClose,
    actionItems = []
}: DialogAppBarProp) {

    return (
        <AppBar elevation={0}>
            <Toolbar>
                <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                    <Box display="flex" alignItems="center">
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            {title}
                        </Typography>
                    </Box>

                    <Box display="flex" alignItems="center" gap={1}>
                        {actionItems.map((i) => i)}
                    </Box>
                </Box>
            </Toolbar>
        </AppBar>
    )
}

interface DialogAppBarProp {
    title: string,
    handleClose: () => void,
    actionItems?: JSX.Element[]
}